var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2301,
    height: 1428.454,
    viewBox: "0 0 2301 1428.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28134",
    "data-name": "Group 28134",
    transform: "translate(339 33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1390",
    "data-name": "Rectangle 1390",
    transform: "translate(900.824 629.594) rotate(-34)",
    fill: "#fafafa",
    stroke: "#a3a5a8",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 40,
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("rect", {
    width: 366.188,
    height: 366.188,
    rx: 104,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 406.188,
    height: 406.188,
    rx: 124,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1397",
    "data-name": "Rectangle 1397",
    transform: "matrix(-0.719, 0.695, -0.695, -0.719, 517.789, 1084.519)",
    fill: "#fafafa",
    stroke: "#a3a5a8",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 40,
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("rect", {
    width: 366.188,
    height: 366.188,
    rx: 126,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 406.188,
    height: 406.188,
    rx: 146,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7428",
    "data-name": "Group 7428",
    transform: "translate(-148 -142)",
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_650",
    "data-name": "Ellipse 650",
    transform: "translate(-191 248)",
    fill: "none",
    stroke: "#a3a5a8",
    strokeWidth: 100
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 368,
    r: 368,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 368,
    r: 318,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_651",
    "data-name": "Ellipse 651",
    cx: 268,
    cy: 268,
    r: 268,
    transform: "translate(-91 348)",
    fill: "#f2f3f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7456",
    "data-name": "Group 7456",
    transform: "translate(1819.301 -280.699)",
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_650-2",
    "data-name": "Ellipse 650",
    transform: "translate(-191.301 247.699)",
    fill: "none",
    stroke: "#a3a5a8",
    strokeWidth: 100
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 167,
    r: 167,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 167,
    r: 117,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_651-2",
    "data-name": "Ellipse 651",
    cx: 121,
    cy: 121,
    r: 121,
    transform: "translate(-145.301 293.699)",
    fill: "#f2f3f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28131",
    "data-name": "Group 28131",
    transform: "translate(736.301 -6.699)",
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_650-3",
    "data-name": "Ellipse 650",
    transform: "translate(-191.301 247.699)",
    fill: "none",
    stroke: "#a3a5a8",
    strokeWidth: 100
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 167,
    r: 167,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 167,
    r: 117,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_651-3",
    "data-name": "Ellipse 651",
    cx: 121,
    cy: 121,
    r: 121,
    transform: "translate(-145.301 293.699)",
    fill: "#f2f3f5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern);
export default __webpack_public_path__ + "static/media/bg-pattern.fc5e6fbb14ab58f3d9da0799f35e1d47.svg";
export { ForwardRef as ReactComponent };